import React from 'react';
import AppContainer from 'stores/AppContainer';
import routes from 'lib/routes';
import { Redirect } from 'react-router-dom';
import logout from 'lib/logout';

function redirectTo(path, locationObject = false) {
    if (locationObject) {
        // See: https://tylermcginnis.com/react-router-protected-routes-authentication/
        return (
            <Redirect to={{
                pathname: path,
                state: { from: locationObject }
            }} />
        );
    }
    return (<Redirect to={path} />);
}

redirectTo.toLogin = (locationObject = false) => {
    return redirectTo(routes.login, locationObject);
};

redirectTo.toHome = (locationObject = false) => {
    return redirectTo(routes.home, locationObject);
};

export default function useAuthenticate() {
    const { getCurrentUser, removeCurrentUser } = AppContainer.useContainer();
    const user = getCurrentUser();
    if (!user) {
        return [null, redirectTo];
    }
    user.remove = () => removeCurrentUser;
    user.logout = async () => {
        await logout();
        removeCurrentUser();
    };
    return [user, redirectTo];
}